import React, {useEffect} from 'react';
import type {RuleConditionState, CounterState, DurationState} from '../../../modules/ruleengine/types';
import type {SettingOption} from './constants';
import {AFTER_X_HOURS, AFTER_X_MINUTES, AFTER_X_TIMES} from './constants';
import TriggerOptionalSettingsTooltip from './TriggerOptionalSettingsTooltip';
import TriggerOptionalSettingsCounterInput from './TriggerOptionalSettingsCounterInput';
import TriggerOptionalSettingsMinutesInput from './TriggerOptionalSettingsMinutesInput';
import TriggerOptionalSettingsHoursInput from './TriggerOptionalSettingsHoursInput';
import {COUNTER_TRIGGER_MIN_VALUE, DURATION_TRIGGER_MIN_VALUE} from '../../../modules/ruleengine/config/consts';
type TriggerOptionalSettingsInputProps = {
	onChange: (arg0: Partial<RuleConditionState>) => void;
	disabled: boolean;
	selectedSetting: SettingOption;
	counterState?: CounterState;
	durationState?: DurationState;
};
type Props = TriggerOptionalSettingsInputProps;

const TriggerOptionalSettingsInput = ({selectedSetting, counterState, durationState, disabled, onChange}: Props) => {
	const counter = counterState ? counterState.conditionCount : undefined;
	const duration = durationState ? durationState.durationInMin : undefined;
	useEffect(() => {
		onChange({
			duration:
				selectedSetting === AFTER_X_HOURS || selectedSetting === AFTER_X_MINUTES
					? {
							durationInMin:
								selectedSetting === AFTER_X_HOURS
									? Math.max(60, Math.floor((duration || 1) / 60) * 60)
									: duration || DURATION_TRIGGER_MIN_VALUE
					  }
					: undefined,
			counter:
				selectedSetting === AFTER_X_TIMES
					? {
							conditionCount: counter || COUNTER_TRIGGER_MIN_VALUE
					  }
					: undefined
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSetting]);
	return (
		<>
			{selectedSetting === AFTER_X_TIMES && (
				<TriggerOptionalSettingsCounterInput
					disabled={disabled}
					onChange={onChange}
					value={counter || undefined}
				/>
			)}
			{selectedSetting === AFTER_X_MINUTES && (
				<TriggerOptionalSettingsMinutesInput
					disabled={disabled}
					onChange={onChange}
					value={duration || undefined}
				/>
			)}
			{selectedSetting === AFTER_X_HOURS && (
				<TriggerOptionalSettingsHoursInput
					disabled={disabled}
					onChange={onChange}
					value={duration || undefined}
				/>
			)}
			<TriggerOptionalSettingsTooltip counter={counter} duration={duration} selectedSetting={selectedSetting} />
		</>
	);
};

export default TriggerOptionalSettingsInput;
